import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { jSith } from "../../../../util/jquery-replacement";
import { LineItemI } from "../../../../pojo/Pricing";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { S25PricingUtil } from "../../s25.pricing.util";

@TypeManagerDecorator("s25-ng-pricing-subtotal-charges")
@Component({
    selector: "s25-ng-pricing-subtotal-charges",
    template: `@if (init) {
        <div>
            @for (item of adjustments; track item) {
                <div class="c-margin-bottom--half">
                    <span>{{ item.total_charge | currency }}</span>
                </div>
            }
        </div>
    }`,
    styles: `
        :host ::ng-deep .c-svgIcon {
            position: relative;
            bottom: 1px;
        }

        .pricing-tooltip-wrapper {
            display: flex;
            position: relative;
        }

        :host ::ng-deep s25-ng-info-message {
            position: unset;
            transition: unset;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25PricingSubtotalChargesComponent implements OnInit {
    @Input() allBillItems: LineItemI[];

    init: boolean;
    adjustments: LineItemI[] = [];

    ngOnInit() {
        jSith.forEach(this.allBillItems, (_, billItem: LineItemI) => {
            //passed in by pricing-service footerF supplied to getPricingOrganizationListFn
            if (billItem.bill_item_type_id === -1 && !isNaN(parseFloat(billItem.adjustment_amt))) {
                this.adjustments.push(billItem);
            }
        });

        jSith.forEach(this.allBillItems, (_, billItem: LineItemI) => {
            if (billItem.bill_item_type_id === -1 && !isNaN(parseFloat(billItem.adjustment_percent))) {
                this.adjustments.push(billItem);
            }
        });

        this.init = true;
    }
}
